const getLinkedInSingleImageBaseStyles = () => ({
  placementCard: {
    borderRadius: '0 !important',
  },
  placementCardHeader: undefined,
  placementCardPreview: undefined,
  placementCardFooter: undefined,
  placementLogo: undefined,
  placementCompanyName: undefined,
  placementPromoteText: undefined,
  placementImageContainer: undefined,
  placementIntroductoryText: undefined,
  placementHeadline: undefined,
  placementFinalUrl: undefined,
  placementCallToAction: undefined,
});

export const getImageExtensionPlacementBaseStyles = () => ({
});
export const getLinkedInSingleImageDesktopStyles = theme => ({
  // base styles
  ...getLinkedInSingleImageBaseStyles(theme),

  // overrides
  placementCard: {
    height: '100%',
    gap: '0px  !important',
    paddingLeft: '0px  !important',
    paddingRight: '0px  !important',
    paddingBottom: '0px !important',
    '--fui-Card--size': '9.39px !important',
  },
  placementCardHeader: {
    marginBottom: '4.69px',
    paddingLeft: '9.39px',
    paddingRight: '9.39px',
    flexDirection: 'column', // Stack company name and promote text vertically
    alignItems: 'center', // Align to the start of the flex container
    '--fui-CardHeader--gap': '4.69px  !important',
  },
  placementLogo: {
    width: '20px',
    height: '20px',
  },
  placementCompanyName: {
    color: '#323130',
    fontFamily: 'Segoe UI',
    fontSize: 8.216,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '11.737px',
    letterSpacing: '-0.293px',
  },
  placementPromoteText: {
    fontSize: '7.042px !important',
    color: '#323130',
    lineHeight: '11.737px !important',
  },
  placementIntroductoryText: {
    marginTop: '0px',
    paddingLeft: '9.39px',
    paddingRight: '9.39px',
    marginBottom: '4.69px',
    fontSize: '8.216px  !important',
  },
  placementCardPreview: {
    display: 'flex',
  },
  placementImageContainer: {
  },
  placementCardFooter: {
    display: 'flex',
    paddingTop: '4.69px',
    paddingBottom: '4.69px',
    paddingLeft: '9.39px',
    paddingRight: '9.39px',
    borderWidth: '1px',
    justifyContent: 'space-between',
    background: '#ECF1F6',
  },
  placementHeadline: {
    margin: '0px !important',
    overflow: 'hidden !important',
    display: '-webkit-box !important',
    WebkitBoxOrient: 'vertical !important',
    WebkitLineClamp: '2 !important',
    padding: '0px !important',
    fontSize: '8.216px !important',
    fontWeight: '600 !important',
    color: '#323130 !important',
  },
  placementFinalUrl: {
    margin: '0px',
    padding: '0px',
    border: '0px',
    display: 'block !important',
    fontSize: '7.042px !important',
    color: '#323130 !important',
  },
  placementCallToAction: {
    cursor: 'pointer !important',
    textDecorationLine: 'none !important',
    minHeight: '22px !important',
    minWidth: '0px !important',
    borderRadius: '11.737px !important',
    textAlign: 'center !important',
    fontSize: '8.216px !important',
    fontWeight: '700 !important',
    lineHeight: '9.389px !important',
    boxShadow: '0 0 0 1px #0a66c2 !important',
    color: '#004182 !important',
    display: 'flex',
    height: 14.084,
    padding: '3.521px 7.042px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ECF1F6 !important',
  },

});

export const getLinkedInSingleImageMobileStyles = theme => ({
  ...getLinkedInSingleImageDesktopStyles(theme),
});

export const getLinkedInSingleImageMediumRectangleStyles = theme => ({
  // base styles
  ...getLinkedInSingleImageBaseStyles(theme),

  // overrides
  placementCard: {
    height: '100%',
    '--fui-Card--size': '9.39px !important',
  },
  placementLogo: {
    width: '10px !important',
    height: '10px !important',
  },
  placementCompanyName: {
    color: '#323130 !important',
    fontFamily: 'Segoe UI !important',
    fontSize: '8.216px !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    lineHeight: '11.737px !important',
    letterSpacing: '-0.293px !important',
    WebkitLineClamp: '1 !important',
    WebkitBoxOrient: 'vertical !important',
    marginLeft: '5px !important',
  },
  placementCardPreview: {
    display: 'flex !important',
  },
  placementCardFooter: {
    display: 'flex !important',
    flexDirection: 'column  !important',
    paddingTop: '9.39px',
    gap: '9.39px  !important',
  },
  placementHeadline: {
    color: '#323130 !important',
    fontFamily: 'Segoe UI !important',
    fontSize: '8.216px !important',
    fontStyle: 'normal !important',
    fontWeight: '700 !important',
    lineHeight: '11.737px !important',
    letterSpacing: '-0.293px !important',
    display: '-webkit-box  !important',
  },
  placementCompanyMeta: {
    display: '-webkit-flex !important',
  },
  placementHeader: {
    display: '-webkit-flex !important',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  placementCallToAction: {
    display: 'flex !important',
    padding: '2.004px 5.344px !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    borderRadius: '2.725px !important',
    background: '#355996 !important',
    fontFamily: 'Segoe UI !important',
    fontSize: '8.216px !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    lineHeight: '11px !important',
    color: '#FFFFFF !important',
    minWidth: '0px !important',
  },
});

export const getLinkedInSingleImageMobileInterstitialStyles = theme => ({
  ...getLinkedInSingleImageMediumRectangleStyles(theme),

  placementIntroductoryText: {
    height: '60.891px !important',
    flexShrink: '0 !important',
    alignSelf: 'stretch !important',
    color: '#323130 !important',
    fontFamily: 'Segoe UI !important',
    fontSize: '8.216px !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    lineHeight: '11.737px !important',
    letterSpacing: '-0.293px !important',
  },
  placementCompanyMeta: {
    display: '-webkit-flex !important',
  },
  placementHeader: {
    display: '-webkit-flex !important',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '5.87px',
  },
});

export const getLinkedInSingleImageNativeStyles = theme => ({
  ...getLinkedInSingleImageMediumRectangleStyles(theme),

  placementCardHeader: {
    alignItems: 'center !important',
    flexDirection: 'column !important',
    '--fui-CardHeader--gap': '4.69px !important',
  },
  placementLogo: {
    width: '20px',
    height: '20px',
  },
  placementCompanyName: {
    color: '#323130',
    fontFamily: 'Segoe UI',
    fontSize: 8.216,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '11.737px',
    letterSpacing: '-0.293px',
  },
  placementHeader: {
    display: '-webkit-flex !important',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '5.87px',
  },
  placementPromoteText: {
    fontSize: '7.042px !important',
    color: '#323130',
    lineHeight: '11.737px !important',
  },
  placementIntroductoryText: {
    fontSize: '8.216px  !important',
  },
  placementCardFooter: {
    paddingTop: '9.39px',
    justifyContent: 'space-between',
    flexDirection: 'row  !important',
  },
});
